import axios from "../axios";

export async function fetchVehicleCards(params) {
  return axios({ method: "get", url: "/vehicle_cards", params })
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
}

export async function createVehicleCard(payload) {
  return axios
    .post("/vehicle_cards", payload)
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
}

export async function updateVehicleCard(payload) {
  const { id, ...rest } = payload;
  return axios
    .put(`/vehicle_cards/${id}`, rest)
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
}

export async function deactivateVehicleCard(id) {
  return axios
    .put(`/vehicle_cards/${id}/deactivate`)
    .then((r) => r.data)
    .catch((e) => e);
}
